"use strict"

module.exports = require('./nsky-legend')



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/